import React from 'react';

export const AICoach: React.FC = () => {
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-6">AI Vocal Coach</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Get personalized vocal training from our AI coach.</p>
      </div>
    </div>
  );
};